// отделяем необходимые пропсы для передачи в компонент
var getListPopoverDesktopProps = function (props) {
    var Popover = props.Popover, popoverProps = props.popoverProps, _a = props.popoverPosition, popoverPosition = _a === void 0 ? 'bottom-start' : _a, _b = props.preventFlip, preventFlip = _b === void 0 ? true : _b, popperClassName = props.popperClassName, updatePopover = props.updatePopover, zIndexPopover = props.zIndexPopover;
    return {
        Popover: Popover,
        popoverProps: popoverProps,
        popoverPosition: popoverPosition,
        preventFlip: preventFlip,
        popperClassName: popperClassName,
        updatePopover: updatePopover,
        zIndexPopover: zIndexPopover,
    };
};

export { getListPopoverDesktopProps };
